module.exports = __webpack_public_path__ + "static/certificate-hero-100-831b62f846d576647891ce07faa6ca3f.jpg";